import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import {
  AnalyticsLoggerService,
  GENERAL_EVENTS,
} from 'src/app/services/analytics-logger.service';
import { AuthService } from 'src/services/auth/auth.service';

@Component({
  selector: 'ribbon-for-demo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ribbon-for-demo.component.html',
  styleUrl: './ribbon-for-demo.component.scss',
})
export class RibbonForDemoComponent {
  constructor(
    public authService: AuthService,

    private logger: AnalyticsLoggerService
  ) {}

  @Output() onLearnMoreClick = new EventEmitter<void>();
  @Output() onOpenLoginClick = new EventEmitter<void>();
  @Output() onCreateAccountClick = new EventEmitter<void>();

  learnMore() {
    this.logger.logEvent(GENERAL_EVENTS.demoRibbonLearnMoreClicked);
    this.onLearnMoreClick.emit();
  }

  createAccount() {
    this.logger.logEvent(GENERAL_EVENTS.demoRibbonSignupClicked);
    this.onCreateAccountClick.emit();
  }

  logIn() {
    this.logger.logEvent(GENERAL_EVENTS.demoRibbonLoginClicked);
    this.onOpenLoginClick.emit();
  }
}
